import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
// import { getQuotesDataView } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import Icon from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getQuotesDataView } from "@MasterBluePrint/Store/Data/Quote/QuoteSelector";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    quotesDataView: getQuotesDataView(state, state.pages.rfqMyQuotes.getQuotesParameter),
    rfqQuoteDetailPageUrl: getPageLinkByPageType(state, "RfqQuoteDetailPage")?.url,
    language: state.context.session.language,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuotesTableStyles {
    wrapper?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    dataTable?: DataTableProps;
    dataTableHead?: DataTableHeadProps;
    dataTableHeaders?: DataTableHeaderProps;
    dataTableBody?: DataTableBodyProps;
    // dataTableRow?: DataTableRowProps;
    dataTableRow?: InjectableCss;
    quoteNumberHeader?: DataTableHeaderProps;
    typeHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    orderDateHeader?: DataTableHeaderProps;
    expirationDateHeader?: DataTableHeaderProps;
    salesRepHeader?: DataTableHeaderProps;
    userHeader?: DataTableHeaderProps;
    customerHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    quoteNumberCell?: DataTableCellProps;
    quoteLink?: LinkPresentationProps;
    typeCell?: DataTableCellProps;
    statusCell?: DataTableCellProps;
    orderDateCell?: DataTableCellProps;
    expirationDateCell?: DataTableCellProps;
    salesRepCell?: DataTableCellProps;
    userCell?: DataTableCellProps;
    customerCell?: DataTableCellProps;
    shipToCell?: DataTableCellProps;
    orderGrandTotalDisplay?: DataTableCellProps;
    mobileHeading?: InjectableCss;
    quoteView?: InjectableCss;
}

export const rfqQuotesTableStyles: RfqQuotesTableStyles = {
    wrapper: {
        css: css`
            overflow: auto;
            margin-top: -10px;

            @media screen and (max-width: 767px) {
                margin-bottom: 15px;
                margin-top: 10px;
                overflow: hidden;
            }
        `,
    },
    centeringWrapper: {
        css: css`
            height: 18.75rem;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noResultsContainer: {
        css: css`
            text-align: center;
            padding: 20px;
        `,
    },
    noResultsText: {
        size: 16,
        weight: 600,
    },
    customerCell: {
        typographyProps: {
            ellipsis: true,
            css: css`
                display: block;
                max-width: 200px;
            `,
        },
    },
    shipToCell: {
        typographyProps: {
            ellipsis: true,
            css: css`
                display: block;
                max-width: 200px;
            `,
        },
    },
    orderGrandTotalDisplay: {
        alignX: "right",
        css: css`
            font-weight: bold;

            @media screen and (max-width: 1279px) {
                padding: 27px 0;
                .total-value {
                    font-size: 16px;
                }
            }
        `,
    },
    dataTable: {
        css: css`
            border-spacing: 0 15px;
            background: #f7f9fa;
            border-collapse: separate;
            th {
                border-bottom: 0;
                color: #2060AD;
                font-family: 'Roboto', sans-serif;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: .81px;
                line-height: 16px;

                span {
                    font-size: 14px;
                }

                &:first-child {
                    font-weight: normal;
                    letter-spacing: 0;

                    span {
                        font-weight: normal;
                        letter-spacing: 0;
                    }
                }
                
                button {
                    color: #2060AD;
                    font-family: 'Roboto', sans-serif;
                    font-size: 14px;
                    font-weight: bold;
                    letter-spacing: .81px;
                    line-height: 16px;
                    width: auto;  
                }

                svg {
                    color: #2E5BFF;
                }
            }
            td {
                color: #2E384D;
                font-family: 'Lato',sans-serif;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 22px;

                span, a {
                    color: #2E384D !important;
                    font-family: 'Lato',sans-serif;
                    font-size: 14px;
                }
            }

            @media screen and (min-width: 1280px) {
                thead {
                    position: relative;
                    top: 14px;
                    border-radius: 0 0 2px 2px;
                    
                }
                th {
                    height: 40px;
                    background-color: #E5EEF7;
                    width: auto;
                    text-align: left;

                    &:first-child {
                        padding-left: 30px;
                    }
                    &:last-child {
                        padding-right: 30px;
                        min-width: 5.625rem;
                        text-align: right;
                    }
                }
                td {
                    height: 60px;

                    &:first-child {
                        padding-left: 30px;
                    }
                    &:last-child {
                        padding-right: 30px;
                        min-width: 5.625rem;
                    }
                    span.shipping-value {
                        text-transform: capitalize;
                    }
                }

                tbody {
                    th {
                        display: none;
                    }
                }
            }

            @media screen and (min-width: 1300px) {
                th {
                    &:last-child {
                        min-width: 9.625rem;
                    }
                }
                td {
                    &:last-child {
                        min-width: 9.625rem;
                    }
                }
            }

            @media screen and (max-width: 1279px) {
                thead {
                    display: none;
                }

                table,
                tbody,
                tr{
                    display: flex;
                    max-width: 100%;
                    flex-direction: column;

                    td[data-test-selector="orderHistoryTable_tableCell_date"] {
                        display: none;
                    }
                }

                .mob-date-value {
                    position: absolute;
                    right: 40px;
                    color: #2E384D;
                    font-family: Lato;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 22px;
                    text-align: right;
                    font-weight: normal;
                }

                th {
                    background: transparent !important;
                    height: auto !important;
                    border-bottom: 1px solid #D7D7D7 !important;
                    line-height: 24px !important;
                    padding: 4px 10px !important;
                    margin: 0 15px;
                }

                tr {
                    margin-bottom: 10px;
                    
                    &:before {
                        height: 27px;
                        width: 100%;
                        border-radius: 0 0 2px 2px;
                        background-color: #E5EEF7;
                        content: '';
                    }
                }

                td {
                    display: flex;
                    align-content: center;
                    height: auto;
                    border-color: #D7D7D7;
                    line-height: 24px;
                    padding: 4px 10px;
                    margin: 0 15px;
                    justify-content: space-between;

                    &.total-container{
                        padding: 27px 10px;
                        margin: 0 15px;
                        border: none;

                        span:last-child {
                            font-weight: bold;
                            color: #2E384D;
                            font-size: 16px;
                        }
                    }

                    &:first-child {
                        font-weight: normal;
                        letter-spacing: 0;
                        padding: 11px 0 0 10px;
                        
                        span {
                            font-weight: normal;
                            letter-spacing: 0;
                        }
                    }

                    > span {
                        display: inline-flex;
                        align-items: center;
                        max-width: 49%;
                        width: 49%;
                        text-align: right;
                        white-space: normal;
                        justify-content: flex-end;

                        &:first-child {
                            justify-content: flex-start;
                        }

                        &.shipping-value {
                            text-transform: capitalize;
                        }

                        &:last-child {
                            justify-content: flex-end;
                            color: #2E384D;
                            font-family: Lato;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 22px;
                            text-align: right;
                            font-weight: normal;
                        }
                    }

                    a {
                        text-align: right;
                        color: #2E384D !important;
                        font-family: Lato;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 22px;
                        text-align: right;
                        font-weight: normal;

                        span {
                            color: #2E384D !important;
                        }

                    }
                }

            }
        `,
    },
    dataTableRow: {
        css: css`
            &:nth-child(even) {
                background: #fff;
            }
            @media screen and (min-width: 1280px) {
                box-shadow: 0 2px 12px 0 rgba(0,37,84,0.04);
                td {
                    border-bottom: none;
                }
            }
        `,
    },
    quoteView: {
        css: css`
            padding: 0 .938rem;
            position: relative;
            text-align: center;
            align-items: center;
            justify-content: center;

            @media screen and (min-width: 1280px) {
                text-align: -webkit-left;
                justify-content: flex-start;
                margin-left: 0 !important;
                padding-left: 0 !important;
                &:after {
                    right: auto;
                    left: 2.5rem;
                }
            }

            &:after {
                content: '';
                display: block;
                height: 1.875rem;
                width: .063rem;
                position: absolute;
                right: -.938rem;
                border-right: .063rem solid #E0E0E0;
            }

            @media screen and (max-width: 1279px) {
                &:after {
                    content: none;
                }
            }
        `,
    },
    mobileHeading: {
        css: css`
            @media screen and (min-width: 1280px) {
                display: none;
            }

            @media screen and (max-width: 1279px) {
                background: none;
                display: inline-flex;
                width: 49%;
                color: #2060AD;
                font-family: 'Roboto', sans-serif !important;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: .81px;
                line-height: 16px;
                align-items: center;
                text-align: left;
                padding: 0;
                height: auto;

                &.mobile-heading {
                    color: #2060AD !important;
                }

                button {
                    span {
                        font-weight: bold !important;
                        font-size: 14px;
                    }
                }
            }
        `,
    },
};

const styles = rfqQuotesTableStyles;

const RfqQuoteTable = ({ session, quotesDataView, rfqQuoteDetailPageUrl, language }: Props) => {
    const quotes = quotesDataView.value;
    if (!quotes) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner}></LoadingSpinner>
            </StyledWrapper>
        );
    }

    if (quotes?.length === 0) {
        return (
            <StyledWrapper {...styles.noResultsContainer}>
                <Typography {...styles.noResultsText}>{translate("No quotes found")}</Typography>
            </StyledWrapper>
        );
    }
    const rows = quotes?.map(quote => ({
        id: quote.id,
        quoteNumber: quote.quoteNumber,
        type: quote.typeDisplay,
        status: quote.statusDisplay,
        orderDate: quote.orderDate ? getLocalizedDateTime({ dateTime: new Date(quote.orderDate), language }) : "",
        expirationDate: quote.expirationDate
            ? getLocalizedDateTime({ dateTime: new Date(quote.expirationDate), language })
            : "",
        salesRep: quote.salespersonName,
        user: quote.userName,
        customer: quote.customerName,
        shipTo: quote.shipToFullAddress,
        orderGrandTotalDisplay:quote.orderGrandTotalDisplay
    }));

    return (
        <StyledWrapper {...styles.wrapper}>
            <DataTable {...styles.dataTable} data-test-selector="rfqMyQuotes_quoteTable">
                <DataTableHead {...styles.dataTableHead}>
                    <DataTableHeader {...styles.orderDateHeader}>
                        {translate("View", "View")}
                    </DataTableHeader>
                    <DataTableHeader {...styles.quoteNumberHeader} title={translate("Quote Number")}>
                        {translate("Quote #")}
                    </DataTableHeader>   
                    <DataTableHeader tight {...styles.orderDateHeader}>
                        {translate("Created Date")}
                    </DataTableHeader>
                    <DataTableHeader tight {...styles.expirationDateHeader}>
                        {translate("Expiration Date")}
                    </DataTableHeader>
                    <DataTableHeader tight {...styles.expirationDateHeader}>
                        {translate("Requested By")}
                    </DataTableHeader>
                   
                    <DataTableHeader tight {...styles.customerHeader}>
                        {translate("Quote Total")}
                    </DataTableHeader>
                   
                </DataTableHead>
                <DataTableBody {...styles.dataTableBody} data-test-selector="quoteTable_tableBody">
                    {rows?.map(
                        ({
                            id,
                            quoteNumber,
                            type,
                            status,
                            orderDate,
                            expirationDate,
                            salesRep,
                            user,
                            customer,
                            shipTo,
                            orderGrandTotalDisplay,
                        }) => (
                            <DataTableRow
                                key={id}
                                {...styles.dataTableRow}
                                data-test-selector={`rfqMyQuotes_quoteLine_${id}`}
                            >

                                <DataTableCell>
                                    <Typography {...styles.mobileHeading} className="mobile-heading">
                                        {translate("View", "View")}
                                    </Typography>
                                    {quoteNumber !== " " ? (
                                        <Link href={`${rfqQuoteDetailPageUrl}?quoteId=${quoteNumber}`}  {...styles.quoteView}>
                                            <Icon src="Eye" size={24} />
                                        </Link>
                                    ) :
                                        <Link href={`${rfqQuoteDetailPageUrl}?quoteId=${quoteNumber}`}  {...styles.quoteView}>
                                            <Icon src="Eye" size={24} />
                                        </Link>
                                    }

                                </DataTableCell>

                                <DataTableCell {...styles.quoteNumberCell}>
                                    <Typography {...styles.mobileHeading} className="mobile-heading">
                                            {translate("Quote #", "quoteNumber")}
                                    </Typography>
                                    <Link
                                        {...styles.quoteLink}
                                        href={`${rfqQuoteDetailPageUrl}?quoteId=${id}`}
                                        data-test-selector="link"
                                    >
                                        {quoteNumber}
                                    </Link>
                                </DataTableCell>     
                                <DataTableCell {...styles.orderDateCell}>
                                    <Typography {...styles.mobileHeading} className="mobile-heading">
                                        {translate("Quote Created Date", "orderDate")}
                                    </Typography>
                                    <Typography>{orderDate}</Typography>
                                </DataTableCell>
                                <DataTableCell {...styles.expirationDateCell}>
                                    <Typography {...styles.mobileHeading} className="mobile-heading">
                                        {translate("Expiration Date", "expirationDate")}
                                    </Typography>
                                    <Typography>{expirationDate}</Typography>
                                </DataTableCell>
                                <DataTableCell {...styles.statusCell}>
                                    <Typography {...styles.mobileHeading} className="mobile-heading">
                                        {translate("Requested by", "")}
                                    </Typography>
                                    <Typography></Typography>    
                                </DataTableCell>                               
                                <DataTableCell {...styles.orderGrandTotalDisplay} className="total-container">
                                    <Typography {...styles.mobileHeading} className="total-label mobile-heading">
                                        {translate("Cart Subtotal", "orderGrandTotalDisplay")}
                                    </Typography>
                                    <Typography className="total-value">{orderGrandTotalDisplay}</Typography>
                                </DataTableCell>                               
                            </DataTableRow>
                        ),
                    )}
                </DataTableBody>
            </DataTable>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteTable),
    definition: {
        group: "RFQ My Quotes",
        displayName: "Search Results Table",
        // allowedContexts: ["RfqMyQuotesPage"],
    },
};

export default widgetModule;
